import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const AGBPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#121212] text-gray-200">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Button
          data-testid="agb-back-btn"
          onClick={() => navigate(-1)}
          variant="ghost"
          className="text-gray-400 hover:text-white mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" /> Zurück
        </Button>

        <h1 data-testid="agb-title" className="text-3xl sm:text-4xl font-bold text-white mb-8">
          Allgemeine Geschäftsbedingungen (AGB)
        </h1>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">§ 1 Geltungsbereich</h2>
            <p className="text-gray-300">
              (1) Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der Web-Anwendung
              „OddsCortex" (nachfolgend „Dienst"). Der Dienst wird von Allgaeu Travel & Transport E-GmbH,
              Stanko-Valchanov-Str. 5, 9006 Varna (nachfolgend „Anbieter") betrieben.
            </p>
            <p className="text-gray-300 mt-2">
              (2) Mit der Registrierung erkennt der Nutzer diese AGB an.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">§ 2 Leistungsbeschreibung</h2>
            <p className="text-gray-300">
              (1) OddsCortex ist eine KI-gestützte Analyse-Software für Sportereignisse. Der Dienst
              generiert statistische Analysen und Einschätzungen zu Sportereignissen auf Basis von
              öffentlich verfügbaren Daten und KI-Algorithmen.
            </p>
            <p className="text-gray-300 mt-2">
              (2) Die bereitgestellten Analysen und Tipps stellen <strong className="text-white">
              keine Wettberatung, Finanzberatung oder Empfehlung zum Platzieren von Wetten dar</strong>.
            </p>
            <p className="text-gray-300 mt-2">
              (3) Der Anbieter garantiert weder die Richtigkeit noch die Vollständigkeit der
              bereitgestellten Analysen. Vergangene Ergebnisse sind kein Indikator für zukünftige Ergebnisse.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">§ 3 Registrierung & Nutzerkonto</h2>
            <p className="text-gray-300">
              (1) Die Nutzung des Dienstes erfordert eine Registrierung. Der Nutzer muss mindestens
              18 Jahre alt sein.
            </p>
            <p className="text-gray-300 mt-2">
              (2) Der Nutzer ist verpflichtet, wahrheitsgemäße Angaben zu machen und seine Zugangsdaten
              geheim zu halten.
            </p>
            <p className="text-gray-300 mt-2">
              (3) Der Anbieter behält sich das Recht vor, Konten bei Verstoß gegen diese AGB zu sperren.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">§ 4 Abonnements & Zahlungen</h2>
            <p className="text-gray-300">
              (1) Der Dienst bietet verschiedene Abonnement-Stufen (Mini, Small, Medium, Large, XL, XXL,
              Unlimited) mit unterschiedlichem Tipp-Kontingent an.
            </p>
            <p className="text-gray-300 mt-2">
              (2) Die Zahlung erfolgt über PayPal. Es gelten die jeweiligen Preise zum Zeitpunkt des Kaufs.
            </p>
            <p className="text-gray-300 mt-2">
              (3) Abonnements verlängern sich monatlich. Eine Kündigung ist jederzeit zum Ende der
              aktuellen Abrechnungsperiode möglich.
            </p>
            <p className="text-gray-300 mt-2">
              (4) Nicht genutzte Tipps verfallen am Ende des Abrechnungszeitraums.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">§ 5 Widerrufsrecht</h2>
            <p className="text-gray-300">
              (1) Verbraucher haben ein 14-tägiges Widerrufsrecht ab Vertragsschluss.
            </p>
            <p className="text-gray-300 mt-2">
              (2) Das Widerrufsrecht erlischt vorzeitig, wenn der Nutzer innerhalb der Widerrufsfrist
              Tipps abgerufen hat und der Nutzer dem ausdrücklich zugestimmt hat.
            </p>
            <p className="text-gray-300 mt-2">
              (3) Der Widerruf ist über den KI-Support in der App zu richten.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">§ 6 Haftungsausschluss</h2>
            <div className="bg-[#1E1E1E] border border-yellow-400/30 rounded-xl p-6">
              <p className="text-gray-300">
                (1) <strong className="text-yellow-400">Der Anbieter haftet nicht für Verluste, die durch das Befolgen
                der bereitgestellten Analysen und Tipps entstehen.</strong> Die Nutzung der Tipps zum Platzieren
                von Wetten erfolgt ausschließlich auf eigenes Risiko des Nutzers.
              </p>
              <p className="text-gray-300 mt-2">
                (2) Der Anbieter haftet nicht für die vorübergehende Nichtverfügbarkeit des Dienstes
                aufgrund technischer Wartungsarbeiten oder Störungen.
              </p>
              <p className="text-gray-300 mt-2">
                (3) Die Haftung des Anbieters ist auf Vorsatz und grobe Fahrlässigkeit beschränkt,
                soweit gesetzlich zulässig.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">§ 7 Jugendschutz</h2>
            <p className="text-gray-300">
              (1) Der Dienst richtet sich ausschließlich an Personen, die das 18. Lebensjahr
              vollendet haben.
            </p>
            <p className="text-gray-300 mt-2">
              (2) Bei der Registrierung bestätigt der Nutzer, mindestens 18 Jahre alt zu sein.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">§ 8 Spielsuchtprävention</h2>
            <p className="text-gray-300">
              (1) Der Anbieter weist ausdrücklich darauf hin, dass Sportwetten süchtig machen können.
            </p>
            <p className="text-gray-300 mt-2">
              (2) Hilfsangebote: Bundeszentrale für gesundheitliche Aufklärung (BZgA):{' '}
              <a href="https://www.bzga.de" className="text-[#00BFA6] underline" target="_blank" rel="noopener noreferrer">
                www.bzga.de
              </a>
              , Telefon: 0800 1 37 27 00 (kostenlos und anonym).
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">§ 9 Community-Funktionen</h2>
            <p className="text-gray-300">
              (1) Der Dienst bietet soziale Funktionen wie einen Community-Feed, Ranglisten und
              Herausforderungen. Die Teilnahme ist freiwillig.
            </p>
            <p className="text-gray-300 mt-2">
              (2) Im Community-Feed werden Wetten anonymisiert dargestellt. Es werden keine persönlichen
              Daten anderer Nutzer offengelegt.
            </p>
            <p className="text-gray-300 mt-2">
              (3) Der Anbieter behält sich das Recht vor, Community-Inhalte zu moderieren oder zu entfernen.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">§ 10 Änderungen der AGB</h2>
            <p className="text-gray-300">
              Der Anbieter behält sich vor, diese AGB zu ändern. Über wesentliche Änderungen wird der
              Nutzer per E-Mail informiert. Die fortgesetzte Nutzung des Dienstes nach Inkrafttreten
              der Änderungen gilt als Zustimmung.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">§ 11 Schlussbestimmungen</h2>
            <p className="text-gray-300">
              (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des
              UN-Kaufrechts.
            </p>
            <p className="text-gray-300 mt-2">
              (2) Gerichtsstand für Streitigkeiten mit Unternehmern ist Berlin.
            </p>
            <p className="text-gray-300 mt-2">
              (3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit
              der übrigen Bestimmungen unberührt.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-gray-500 text-xs">
          Stand: März 2026
        </div>
      </div>
    </div>
  );
};

export default AGBPage;
